import { useEffect, useState } from "react";
import useFetchWrapper, { HttpResponse } from "../../../Helpers/useFetchWrapper";
import { Props, ResourceResponse, TabStatus, TableData } from "./Survey.model";
import moment from "moment";
import { Filters } from "../BackofficeSurveys.model";

export const pageSize = 10;

export const useSurvey = ({filters}:Props) => {
  const [historySurveys, setHistorySurveys] = useState<TableData[]>();
  const [ historySurveysPagination, setHistorySurveysPagination ] = useState({ page: 1, size: pageSize, total: 0 });
	const [ tabStatus, setTabStatus ] = useState<TabStatus>(TabStatus.Loading);
  const { get } = useFetchWrapper();

	useEffect(() => {
		if (historySurveysPagination.page > 1) {
			setHistorySurveysPagination({
				...historySurveysPagination,
				page: 1,
			});
		} else {
			getSurveys();
		}
	}, [filters]);

	useEffect(() => {
		getSurveys()
	}, [historySurveysPagination.page]);

	const getFiltersAsQueryParams = (obj: Filters | null) => {
   	return (
			obj &&
			Object.keys(obj).map((key: string) => {
				if(key === 'date') return `${key}=${obj[key]?.toISOString()}`;
				return `${key}=${obj[key]}`.split(",").join("&");
			}).join("&")
		);
	};

	const getSurveys = async () => {

		setTabStatus(TabStatus.Loading);

		const response: HttpResponse<ResourceResponse> = await get(`/survey/all?page=${historySurveysPagination.page}&size=${historySurveysPagination.size}&${getFiltersAsQueryParams(filters)}`);
    
		if (response.parsedBody) {
      const surveys: TableData[] = response?.parsedBody?.surveys.map((item, index) => ({
        date: moment(item.date).format("DD MMM YYYY"),
        id: item.id,
				key: index,
				surveyType: item.surveyType,
      }));
      setHistorySurveys(surveys);
      setHistorySurveysPagination({...historySurveysPagination, total: response.parsedBody.count})
      setTabStatus(TabStatus.Loaded)
    }
    else {
      setTabStatus(TabStatus.Error);
    }
  };
	

  const onChangeHistorySurveysPagination = (page: number) => {
		setHistorySurveysPagination({ ...historySurveysPagination, page, });
	};
  
	return {
		getSurveys,
		onChangeHistorySurveysPagination,
    state: { historySurveys, historySurveysPagination, tabStatus },
  }
};